import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingView } from 'day8-react';
import { ComponentVerticalSpacing, ComponentWrapper } from 'day8-react/build/new-components';
import ArrivalInfo from './booking/booking-page-tabs/tabs/ArrivalInfo';

class PublicArrivalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      week: null
    };

    this.parseWeekIdHash = this.parseWeekIdHash.bind(this);
  }

  componentDidMount() {
    this.parseWeekIdHash();
  }

  parseWeekIdHash() {
    const weekIdHash = this.props.match.params.weekIdHash;
    fetch(`/api/arrival-info/${weekIdHash}`, {
      credentials: 'same-origin'
    })
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          this.setState({ week: response.data });
        }
      });
  }

  render() {
    const { week } = this.state;
    if (!week) {
      return <LoadingView title="Loading your week.." />;
    }
    return (
      <ComponentVerticalSpacing>
        <ComponentWrapper className="max-width-sm">
          <ArrivalInfo week={week} />
        </ComponentWrapper>
      </ComponentVerticalSpacing>
    );
  }
}

PublicArrivalInfo.propTypes = {
  match: PropTypes.object.isRequired
};

export default PublicArrivalInfo;
